// extracted by mini-css-extract-plugin
export default {"footer_links_container":"FooterLinksContainer_footer_links_container__LZIEw"};